import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <IndexSection />
        <MediaSection />
        <AppSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <ContactSection />
        <CardsSection />
        <CarouselSection />
        <CommentsSection />
        <TopicsSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}